<template>
  <div class="hello">
    <h1>{{ msg }}</h1>
    <p>Seja bem vindo!</p>
  </div>
</template>

<script>
import { functions } from "../functions";
import { EventBus } from "@/event-bus";

export default {
  name: "Home",
  props: {
    msg: String,
  },

  created: function () {
    if (!this.isLogged()) {
      return this.$router.push({ name: "Login", params: {} });
    }
    return this.$router.push({
      name: "SubdepList",
      params: { gotoMain: true },
    });
  },

  methods: {
    isLogged: function () {
      const token = window.localStorage.getItem(this.$appTokenKey);
      return !!token;
    },
  },
};
</script>

<style scoped>
</style>
